import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=a28e5a4a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28e5a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28e5a4a')) {
      api.createRecord('a28e5a4a', component.options)
    } else {
      api.reload('a28e5a4a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=a28e5a4a&scoped=true&", function () {
      api.rerender('a28e5a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YvQfb82U5jMh/JS/comp/Voucher-Unit.vue"
export default component.exports